import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { AuthUser, getUserData, logout } from '../../api/auth';
import { I18n } from '../../i18n';
import { environment } from '../../environment';
import {
  SynButtonComponent,
  SynDropdownComponent,
  SynHeaderComponent,
  SynIconButtonComponent,
  SynIconComponent,
  SynMenuComponent,
  SynMenuItemComponent, SynSwitchComponent,
} from '@synergy-design-system/angular';
import { SynSelectEvent } from '@synergy-design-system/components';
import { ServicePortalApi } from '../../api/api';
import { StateService } from '../../api/state';

@Component({
  selector: 'app-header',
  template: `
    <syn-header i18n-label="@@application-name" label="SICK ID Self-Service Portal">
      <nav slot="meta-navigation">

        @if (state.isAdmin()) {
          <div class="flex-row gap-05 align-center" style="font-size: small">
            <span class="label">Support View:</span>
            <syn-switch [(checked)]="this.api.supportView" />
          </div>
        }

        <syn-dropdown placement="bottom-start">
          <syn-icon-button
            id="language"
            name="language_fill"
            label="Language"
            color="neutral"
            slot="trigger"
            data-e2e="header-language"
          />

          <syn-menu id="languageMenu" (synSelectEvent)="onLanguageSelection($event)" #languageMenu>
            <syn-menu-item
              value="en"
              data-e2e="'header-language-en"
              type="checkbox"
              [checked]="isCurrentLanguage('en')"
            >
              English
            </syn-menu-item>
            <syn-menu-item
              value="de"
              data-e2e="'header-language-de"
              type="checkbox"
              [checked]="isCurrentLanguage('de')"
            >
              Deutsch
            </syn-menu-item>
          </syn-menu>
        </syn-dropdown>

        <syn-dropdown placement="bottom-start">
          <syn-icon-button
            id="header-user"
            name="account_circle_fill"
            label="Account"
            color="neutral"
            slot="trigger"
            data-e2e="header-user"
          />

          <syn-menu id="accountMenu">
            <div class="vertical menu">
              <div class="horizontal">
                <syn-icon class="account-icon" name="account_box_fill" />
                <div class="vertical">
                  <div>{{ user.givenName + ' ' + user.familyName }}</div>
                  <div class="email">{{ user.email ?? user.username }}</div>
                </div>
              </div>
              <a [attr.href]="myAccountLink">
                <syn-button variant="filled" i18n="@@header.myAccount">My Account</syn-button>
              </a>
              <syn-button variant="outline" (click)="onLogout()" i18n="@@header.logout">Logout</syn-button>
            </div>
          </syn-menu>
        </syn-dropdown>
      </nav>
    </syn-header>`,
  styles: [
    `
      .vertical {
        display: flex;
        flex-direction: column;
        margin: auto;
      }

      .horizontal {
        display: flex;
        flex-direction: row;
        align-items: center;
        vertical-align: center;
      }

      .menu {
        padding: 0.8em;
        row-gap: 0.8em;
      }

      .email {
        padding-top: 0.2em;
        font-size: smaller;
      }

      .account-icon {
        width: 36px;
        height: 36px;
      }

      syn-button {
        width: 100%;
      }

      /* This removes the burger button to close the side nav, but it can still be closed via ESC :( */
      /*syn-header::part(burger-menu-toggle-button) {*/
      /*  display: none;*/
      /*}*/
    `,
  ],
  imports: [
    SynHeaderComponent,
    SynDropdownComponent,
    SynMenuComponent,
    SynMenuItemComponent,
    SynIconButtonComponent,
    SynButtonComponent,
    SynIconComponent,
    SynSwitchComponent,
  ],
  standalone: true,
})
export class HeaderComponent implements OnInit {
  i18n = inject(I18n);
  state = inject(StateService);
  api = inject(ServicePortalApi);
  user!: AuthUser;

  myAccountLink = environment.authUrl + `realms/sickservices/account`;

  @ViewChild('languageMenu') languageMenu: ElementRef | undefined;

  ngOnInit(): void {
    this.user = getUserData();
  }

  onLanguageSelection(event: SynSelectEvent) {
    if (event.target === this.languageMenu?.nativeElement) {
      const languageId = (event as CustomEvent).detail.item.value;
      console.log('Language selected:', languageId);
      this.i18n.setLanguage(languageId);
      // Reload the page after we changed the language
      location.reload();
    }
  }

  isCurrentLanguage(id: string): boolean {
    return this.i18n.locale === id;
  }

  onLogout() {
    console.log('Logout');
    logout();
  }
}
